import Paper from "@mui/material/Paper";
import React from "react";

    function CustomPaper({children}) {
        return (
            <Paper
                sx={{
                    "& .MuiAutocomplete-listbox": {
                        "& .MuiAutocomplete-option[aria-selected='true']": {
                            backgroundColor: "#EC8D2B",
                            "&.Mui-focused": {
                                backgroundColor: "#EC8D2B",
                            }
                        }
                    },
                    "& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused": {
                        backgroundColor: "#EC8D2B",
                    }
                }}
            >
                {children}
            </Paper>
        );
}
export default CustomPaper;